import React, { forwardRef } from "react";
import { NavLink as RouterNavLink } from "react-router-dom";

const NavLinkWrapper = forwardRef((props, ref) => (
  <RouterNavLink innerRef={ref} {...props} />
));

export default NavLinkWrapper;
